import { api } from '../api.js';
import { router } from '../router.js';
import { showToast, enhanceCodeInput } from '../utils.js';

/** Completes a reset with the emailed code. */
export function renderResetPassword() {
    const remembered = sessionStorage.getItem('resetEmail') ?? '';

    document.getElementById('app').innerHTML = `
        <div class="login-container">
            <h1 class="login-title">Set a new password</h1>
            <p class="login-subtitle">Enter the code from your email and choose a new password.</p>
            <div id="form-error" class="form-error hidden"></div>
            <form id="reset-form" novalidate>
                <div class="form-group">
                    <label for="email">Email</label>
                    <input type="email" id="email" autocomplete="username" required value="${remembered}">
                </div>
                <div class="form-group">
                    <label for="code">Reset code</label>
                    <input type="text" id="code" inputmode="numeric" autocomplete="one-time-code" required
                           ${remembered ? 'autofocus' : ''}>
                </div>
                <div class="form-group">
                    <label for="new-password">New password</label>
                    <input type="password" id="new-password" autocomplete="new-password" required>
                    <p class="form-hint">At least 12 characters, with upper and lower case, a number and a symbol.</p>
                </div>
                <div class="form-group">
                    <label for="confirm-password">Confirm password</label>
                    <input type="password" id="confirm-password" autocomplete="new-password" required>
                </div>
                <button type="submit" id="submit-btn" class="btn btn-primary btn-full-width">Set new password</button>
                <a href="/login" data-link class="forgot-password-link">Back to sign in</a>
            </form>
        </div>`;

    enhanceCodeInput(document.getElementById('code'));

    document.getElementById('reset-form').addEventListener('submit', async (e) => {
        e.preventDefault();
        const error = document.getElementById('form-error');
        error.classList.add('hidden');

        const email = document.getElementById('email').value.trim();
        const code = document.getElementById('code').value.trim();
        const newPassword = document.getElementById('new-password').value;
        const confirm = document.getElementById('confirm-password').value;

        if (newPassword !== confirm) {
            error.textContent = 'Those passwords do not match.';
            error.classList.remove('hidden');
            return;
        }

        const btn = document.getElementById('submit-btn');
        btn.disabled = true;
        btn.textContent = 'Setting...';
        try {
            await api.resetPassword(email, code, newPassword);
            sessionStorage.removeItem('resetEmail');
            showToast('Password updated — please sign in.', 'success');
            await router.navigate('/login');
        } catch (err) {
            error.textContent = err.message ?? 'Could not reset that password';
            error.classList.remove('hidden');
            btn.disabled = false;
            btn.textContent = 'Set new password';
        }
    });
}
